// MerchantType enum - defines the different types of merchants supported by the system
const MerchantType = {
  AutoRepair: 'Auto Repair',
  MedicalAesthetics: 'Medical Aesthetics',
  WholeSalePlatform: 'Whole Sale Platform',
  GamingPlatform: 'Gaming Platform',
  ClothingRetail: 'Clothing Retail',
  RealEstate: 'Real Estate',
  Supermarket: 'Supermarket',
  Salon: 'Salon',
  Restaurant: 'Restaurant',
  Retail: 'Retail',
  KTV: 'KTV',
  Bar: 'Bar',
  Bakery: 'Bakery',
  Grocery: 'Grocery',
  Cafe: 'Cafe',
  Club: 'Club',
  UsedMerchandise: 'UsedMerchandise',
  Other: 'Other',
};

// Array format for select options
const merchantTypes = Object.values(MerchantType).map((type) => ({
  value: type,
  label: type,
}));

export { MerchantType, merchantTypes };
